/**
 * O fantasma de uma tela enquanto o pacote dela baixa (Suspense).
 *
 * Só o conteúdo: a navbar e a barra lateral moram no Chrome, fora do
 * Suspense, e não saem do lugar. Antes este esqueleto desenhava as duas de
 * novo, com OUTRO desenho — era a "navbar que some" a cada troca de aba.
 *
 * As medidas são as da moldura (AppLayout) e da régua: a mesma margem da
 * barra lateral, o mesmo gutter, cartões 4:5 como os da grade de receitas.
 */
const Brilho = ({ className, style }: { className?: string; style?: React.CSSProperties }) => (
  <div className={`skeleton-base ${className ?? ""}`} style={{ borderRadius: 16, ...style }} />
);

const PageSkeleton = () => (
  <div className="min-h-screen bg-background flex flex-col md:flex-row">
    <div className="flex-1 flex flex-col min-w-0 com-barra-lateral">
      <div className="coluna-conteudo w-full max-w-[520px] mx-auto relative flex flex-col min-h-screen">
        <main className="flex-1 w-full" style={{ padding: "28px var(--gutter) 0" }}>
          <Brilho style={{ height: 36, width: "60%" }} />
          <Brilho style={{ height: 20, width: "80%", marginTop: 12 }} />
          <Brilho style={{ height: "var(--alvo-min)", width: "100%", marginTop: 24, borderRadius: 999 }} />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
              gap: 12,
              marginTop: 24,
            }}
          >
            {Array.from({ length: 6 }).map((_, i) => (
              <Brilho key={i} style={{ aspectRatio: "4 / 5", borderRadius: "var(--raio-cartao)" }} />
            ))}
          </div>
        </main>
      </div>
    </div>
  </div>
);

export default PageSkeleton;
